module.exports = __webpack_public_path__ + "static/img/8.d4ba633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/8.png
// module id = zb8i
// module chunks = 0